import { sendSuccessNotice, sendErrorNotice, getCurrentTime, refreshResource } from '@/commons/utils';
import { request_detail, request_list, update_detail, create_detail, remove_detail, export_list } from '@/commons/hpod';
import configs from '@/configs'
import Vue from 'vue';
var FileSaver = require('file-saver');
const endpoint = 'customers'

// initial state
const state = {
    loading: false,
    all: {},
    master: {},
    selected: {
        ID: 0
    }
};

// getters
const getters = {};

// actions
const actions = {
    export_customer({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list(endpoint, res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
            FileSaver.saveAs(blob, `DanhSachKhachHang_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    },
    getCustomerList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            if(param.is_master) {
                commit('setMasterList', data);
            }
            else {
                commit('setCustomerList', data);
            }
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getCustomerDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setCustomerDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    removeCustomerDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa khách hàng.')
            }
            else {
                sendSuccessNotice('Đã xóa khách hàng thành công.')
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setCustomerDetail({ commit }, {data, id, resetPwd}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                data.ModifiedDate = getCurrentTime().format(configs.SQL_DATE_FORMAT);
                data.ModifiedBy = this.state.authentication.user.userid;
                commit("setLoading", { loading: true });
                if(id > 0) {
                    delete data.CreatedDate;
                    delete data.Createdby;
                    update_detail(endpoint, res => {
                        if (res.data.status === 'fail') {
                            sendErrorNotice('Không thể cập nhật khách hàng.')
                        }
                        else if(resetPwd) {
                            refreshResource();
                        }
                        else {
                            sendSuccessNotice('Cập nhật khách hàng thành công.')
                            refreshResource();
                        }
                        resolve(res)
                        commit("setLoading", { loading: false });
                    }, Vue.http, data, id, this.state.authentication.token);
                }
                else {
                    // data.CreatedDate = getCurrentTime().format(configs.SQL_DATE_FORMAT);
                    data.Createdby = this.state.authentication.user.userid;
                    create_detail(endpoint, res => {
                        if (res.data.status === 'fail') {
                            sendErrorNotice('Không thể thêm mới khách hàng.')
                        }
                        else {
                            sendSuccessNotice('Thêm mới khách hàng thành công.');
                            refreshResource();
                        }
                        resolve(res)
                        commit("setLoading", { loading: false });
                    }, Vue.http, data, this.state.authentication.token);
                }
            }, 100)
        })
    },
};

// mutations
const mutations = {
    setCustomerList(state, data) {
        state.all = data;
    },
    setMasterList(state, data) {
        state.master = data;
    },
    setCustomerDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
